import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notification, Upload as AntUpload, Spin } from "antd";
import ImgCrop from "antd-img-crop";

import avatarPlaceholder from "../../assets/images/avatar-placeholder.svg";
import {
  SetUploadAvatarInitial,
  SetUploadAvatarProcess,
} from "redux/store/users/action";
import { SOMETHING_WENT_WRONG } from "constants/staticText";
import { AuthContext } from "contexts/authContext";
import ImageComponent from "./ImageComponent";
import { v4 as uuid } from "uuid";

interface Props {
  avatarURI: string | null;
  apiPath: string;
  uploadMethod?: "POST" | "PUT";
  uploadType: "avatar" | "logo";
}

const Upload = ({
  avatarURI,
  apiPath,
  uploadMethod = "POST",
  uploadType = "avatar",
}: Props) => {
  const {
    upload_avatar_success,
    upload_avatar_failed,
    upload_avatar_processing,
  } = useSelector(
    // @ts-ignore
    (state) => state.users
  );

  const { KState } = useContext(AuthContext);

  const dispatch = useDispatch();

  const [imageURL, setImageURL] = useState(`${avatarURI}` || avatarPlaceholder);

  useEffect(() => {
    return () => {
      dispatch(SetUploadAvatarInitial());
    };
  }, []);

  useEffect(() => {
    if (upload_avatar_success) {
      notification.success({
        message: "Success!",
        description: `${
          uploadType[0].toUpperCase() + uploadType.slice(1)
        } uploaded successfully`,
        placement: "top",
      });
      setImageURL(`${avatarURI}` || avatarPlaceholder);
    } else if (upload_avatar_failed) {
      // notification.error({
      //   message: "Uh Oh!",
      //   description: SOMETHING_WENT_WRONG,
      //   placement: "top",
      // });
    }
  }, [upload_avatar_success, upload_avatar_failed]);

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      // notification.error({
      //   message: "Uh Oh!",
      //   description: "You can only upload JPG/PNG file!",
      // });
      return false;
    }
    const isLt2M = file.size / 1024 <= 128;
    if (!isLt2M) {
      notification.error({
        message: "Uh Oh!",
        description: "Image must smaller than 250 KB!",
      });
      return false;
    }

    const formData = new FormData();
    formData.append(uploadType, file);

    if (KState.keycloak) {
      dispatch(
        SetUploadAvatarProcess({
          data: formData,
          apiPath,
          uploadMethod,
          headers: { Authorization: `Bearer ${KState.keycloak.token}` },
        })
      );
    }

    return isJpgOrPng && isLt2M;
  };

  const MainUploader = (
    <AntUpload
      name="avatar"
      listType="picture-card"
      className="avatar-uploader relative"
      showUploadList={false}
      beforeUpload={beforeUpload}
      onPreview={onPreview}
    >
      <ImageComponent
        className="w-full h-full object-contain upload-avatar "
        imageSource={imageURL}
        alt={uploadType}
      />
      {upload_avatar_processing && (
        <div className="absolute top-0 left-0 w-[102px] bottom-2 bg-white/50 rounded-lg flex items-center justify-center">
          <Spin />
        </div>
      )}
    </AntUpload>
  );

  return uploadType === "avatar" ? (
    <ImgCrop rotationSlider>{MainUploader}</ImgCrop>
  ) : (
    MainUploader
  );
};

export default Upload;
